var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    { attrs: { loading: _vm.isLoading, hasData: !_vm.isLoading } },
    [
      _c("AuthCard", {
        staticClass: "font-strict",
        attrs: { title: _vm.title },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _vm.subscriptionPlansExist
                  ? _c("p", { staticClass: "font-semibold mb-6 text-center" }, [
                      _vm._v(
                        " Choose the best package for your needs now and upgrade as your team expands. "
                      ),
                      _c("br"),
                      _vm._v("Enjoy a 7-day free trial. Cancel anytime. "),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "bg-white py-3 mt-2 px-4 shadow max-w-90" },
                  [
                    !_vm.subscriptionPlansExist
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "text-xl font-semibold mb-3 text-center",
                          },
                          [
                            _vm._v(" We are sorry."),
                            _c("br"),
                            _vm._v(
                              " At the moment, technical work is underway."
                            ),
                            _c("br"),
                            _vm._v(
                              " The app will be available in a few minutes. "
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "mb-5" },
                          [
                            _c("PricePlans", {
                              staticClass: "pt-7",
                              attrs: {
                                subscriptionPlans: _vm.subscriptionPlans,
                                activeManagersCount: _vm.activeManagersCount,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function ({ subscriptionPlanId, title }) {
                                    return [
                                      _c(
                                        "UiButton",
                                        {
                                          attrs: {
                                            variant: "black",
                                            fullWidth: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openPaymentCardPage(
                                                subscriptionPlanId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "uppercase",
                                              class:
                                                title === "Premium"
                                                  ? "font-medium"
                                                  : "font-normal",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  title === "Premium"
                                                    ? "Start with this plan"
                                                    : "Select"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex justify-center mt-5 flex-col items-center adjustFooter",
                  },
                  [
                    _c("p", { staticClass: "mb-2" }, [
                      _vm._v(
                        "Need to adjust later? You can add more manager seats at any time. Select a plan to get started, and enjoy a 7-day free trial on us. Cancel anytime. "
                      ),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }